module.exports = __webpack_public_path__ + "img/bulgaria.15cb5508.svg";